import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useUser } from '@/context/UserContext';

const StyledUser = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  > a{
    margin-right: 32px;
    color: var(--grey);
  }
`;

const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition-duration: 0.3s;
  border: 1px solid white;
  border-radius: 50%;
  &:hover{
    border-color: rgba(var(--greyr), 0.3);
    transform: scale(1.05);
  }

  div{
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 50%;
    background-color: var(--purple);
    color: var(--white);
    font-size: 12px;

  }
  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

const Dropdown = styled.div<{ $isOpen: boolean, $inlineMobile: boolean }>`
  position: absolute;
  top: 100%;
  ${ props => (props.$inlineMobile ? 'left: 0;' : 'right: 0;') }
  ${ props => (props.$inlineMobile ? '' : 'box-shadow: 5px 6px 12px 2px rgba(var(--greyr), 0.3);') }
  margin-top: 18px;
  background: var(--white);
  border-radius: 8px;
    overflow: hidden;
  ${ props => (props.$inlineMobile ? 'min-width: 300px;' : 'min-width: 200px;') }
  display: block;
  opacity: ${props => (props.$isOpen || props.$inlineMobile) ? '1' : '0'};
  pointer-events: ${props => props.$isOpen ? 'all' : 'none'};
  transition-duration: 0.3s;
  z-index: 1000;

  @media (max-width: 968px) {
    pointer-events: ${props => (props.$inlineMobile) ? 'all!important' : '0'};
  }

  .user-details{
    ${ props => (props.$inlineMobile ? 'padding: 18px 0;' : 'padding: 18px;') }
    border-bottom: 1px solid rgba(var(--greyr), 0.3);

    span {
      display: block;
      margin-bottom: 2px;
      font-size: 14px;
      font-weight: 400;
    }

    small {
      display: block;
      font-size: 12px;
      color: var(--grey);
    }
  }
`;


const DropdownItems = styled.div`
  a, button {
    display: block;
    background-color: white;
    color: black;
    padding: 12px 18px;
    text-decoration: none;
    transition: background-color 0.2s;
    cursor: pointer;
    font-size: 14px;
    background: none;
    border: none;
    width: 100%;
    text-align: left;

    &:hover {
      background-color: rgba(var(--blackr), 0.05);
    }
  }
`;

const AppNavbar: React.FC = ({inlineMobile = false}) => {
  const location = useLocation();
  const navigate = useNavigate()
  const { logout } = useAuth();

  const { userProfile } = useUser();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/')
  };

  if (!userProfile) {
    return null;
  }

  return (
    <StyledUser ref={dropdownRef}>

      <UserAvatar onClick={toggleDropdown}>
        {
          userProfile.picture ?
            <img className="jn5jh" alt={userProfile.name} src={`https://proxy.studio14a.com/file?url=${userProfile.picture} `} data-loaded=""/>
            :
            <div>
              {userProfile?.name?.charAt(0)}
            </div>
        }
      </UserAvatar>

      <Dropdown $isOpen={isDropdownOpen} $inlineMobile={inlineMobile}>
        <div className="user-details">
          <span>{userProfile.name}</span>
          <small>{userProfile.email}</small>
        </div>

        <DropdownItems>
          <Link to="/dashboard/profile" onClick={() => setIsDropdownOpen(false)}>
            Your Profile
          </Link>
          {location.pathname.includes('/docs') ?
            <Link to="/dashboard" onClick={() => setIsDropdownOpen(false)}>
              Dashboard
            </Link> :
            <Link to="/docs" onClick={() => setIsDropdownOpen(false)}>
              Docs
            </Link>
          }
          <Link to="/support" onClick={() => setIsDropdownOpen(false)}>
            Support
          </Link>

          <button onClick={handleLogout} type="button">
            Log Out
          </button>
        </DropdownItems>
      </Dropdown>
    </StyledUser>
  );
};

export default AppNavbar;
